import React from "react";
import WithdrawalRequest from "./WithdrawalRequest";

// Same payout desk, opened on the "Cancelled" tab
const CancelWithdrawal = () => <WithdrawalRequest initialTab="cancel" />;

export default CancelWithdrawal;